// @erp/module-fin/fe · the module's typed edge (DEV-GUIDE-002 §6.3 — per-module
// hc client, never one giant hc<AppType>). finApi is hc<FinRoutes> based at
// /api/fin — the mount point the gateway gives createFinRouter. `import type`
// is load-bearing: a VALUE import of '../api' would drag Hono + the repos into
// the browser bundle; type-only, it is erased AND it is the compile-time seam —
// if a fin route leaves the chained expression (or a response shape drifts),
// FinRoutes changes and THIS build fails typecheck. Mirrors
// modules/cms/src/fe/client.ts (including the tsconfig.fe.json
// @cloudflare/workers-types note).
import type { FinRoutes } from "../api/index.js";
import { createApiClient } from "@erp/api-client";

/** The module-scoped hc client. Screens/queries/mutations import THIS, never a portal-wide client. */
export const finApi = createApiClient<FinRoutes>("/api/fin");
export type FinApi = typeof finApi;
